import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ConfirmPopup(props) {
  const { t: tCommon } = useTranslation('common');
  const { data, handleClose, handleOkay, alertTitle, alertContent, successBtnName, isLoading } = props;
  return (
    <Dialog
      open={!!data}
      onClose={() => {
        handleClose('');
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{ style: { zIndex: 2050 } }}
      PaperProps={{ style: { zIndex: 2100 } }}
    >
      <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{alertContent}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose('');
          }}
          color="primary"
          disabled={isLoading}
        >
          {tCommon('Cancel')}
        </Button>
        <Button
          onClick={() => {
            handleOkay(data);
          }}
          color="primary"
          autoFocus
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
              {successBtnName || tCommon('Confirming...')}
            </>
          ) : (
            successBtnName || tCommon('Confirm')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
